<template>
	<!-- <v-text-field  
        :label="titulo"
        :placeholder="placeholder"       
        v-mask="'##/##/####'"
        v-model="value_data"
        :error="error"      
    ></v-text-field> -->
    <!-- <span>
        
        <br><br>--{{value_data}}
        <br><br>--{{search}} -->

        <v-autocomplete
            v-model="value_data"
            :items="items"
            :loading="loading"
            :search-input.sync="search"							
            hide-no-data
            hide-selected
            item-text="label"
            item-value="id"
            :label="label"
            :placeholder="placeholder"
            :error="error"	
            :clearable="clearable"
            :disabled="disabled"
            @change="handleChange"
        >

       
        
        </v-autocomplete>
    <!-- </span> -->
</template>
<script>
import axios from 'axios';	

export default {
    data(){
        return {
            items:[],
            loading:false,
            search:'',
            valorRecuperadoCreated:'',
            recuperadoCreated:false,

            mudouValueLocal:false
        }
    },
    props:{
        label:String,
        placeholder:String,
        value:null,
        error:Boolean,
        id_agregado:null,
        tag_agregado:String,
        itemdefault:null,
        selected:null,
        clearable:null,
        disabled:Boolean,
        arg_extra: null
    },
    computed:{
        value_data:{
            // eslint-disable-next-line vue/return-in-computed-property
            get: function(v) {                
                if(this.itemdefault!=null){
                    return this.itemdefault;
                }else if(this.valorRecuperadoCreated!='' && !this.recuperadoCreated){                    
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.recuperadoCreated = true;                    
                    return this.valorRecuperadoCreated;                    
                }
            },
            set: function(value) {
                // console.log('value', value)

                this.mudouValueLocal = true;
                this.$emit('input', value)
            }
        }
    },
    watch:{
        value(v){
             if(this.mudouValueLocal){
                //  console.log('value local');
                 this.mudouValueLocal = false;
             } else {
                 if(v!=null && v!=''){
                    this.recuperaAgregado(v);
                 }else{
                    this.items = [];                        
                    this.valorRecuperadoCreated = {};
                    this.recuperadoCreated=false;
                 }
             }
            //  else console.log('value externo');
            //  console.log('value',v);
            //  console.log('valueOld',vOld);
        },
        search( search ){
            if (this.items.length > 0) {
                for(let x=0;x < this.items.length; x++){
                    // console.log('LABEL', this.argumentoAgregadoLista['d'][x].label);
                    if(this.items[x].label == search ) return
                }
            }

            // Items have already been requested
            if (this.loading) return

            if(search!= null && search.length >= 2 ){
                this.loading = true

                //console.log('VALOR',val);
                let objAgregado = {chave: search};
                if(this.id_agregado!=null && this.id_agregado!='null'){
                    // console.log('id', this.id_agregado);
                    objAgregado["id"] = this.id_agregado;
                    // console.log('id', objAgregado);
                }else if(this.tag_agregado!=null && this.tag_agregado!=''){
                    // console.log('tag', this.tag_agregado);
                    objAgregado["tag"] = this.tag_agregado;
                    // console.log('tag', objAgregado);
                }

                if (this.arg_extra != null) {
                    objAgregado = {
                        ...objAgregado,
                        ...this.arg_extra
                    }
                }

                axios.get ('/agregados/json/chave',{params: objAgregado})
                .then(res => {					
                    if(res.data){                    
                        if(!res.data.data || res.data.data.length == 0){
                            //this.$toastr('error',"Nenhum registro encontrado");
                            
                            this.items = [];
                        }else{						
                            
                            this.items = res.data.data;
                            
                        }
                    }

                    this.loading = false;
                }, () => {        					
                    // console.log('err',err);
                    this.loading= false;
                    this.items = [];
                    this.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
                }); 

            }
        }
    },
    methods:{
        handleChange() {
            this.$emit('change');
        },
        recuperaAgregado( pk_value ){
            let objAgregado = {pk: pk_value};

            if(this.id_agregado!=null && this.id_agregado!='null'){                
                objAgregado["id"] = this.id_agregado;                
            }else if(this.tag_agregado!=null && this.tag_agregado!=''){                
                objAgregado["tag"] = this.tag_agregado;
                
            }


            axios.get ('/agregados/json/pk',{params: objAgregado})
            .then(res => {					
                if(res.data){                    
                    if(res.data.data && res.data.data.length > 0){                        
                        this.items = res.data.data;                        
                        this.valorRecuperadoCreated = this.items[0];
                        this.recuperadoCreated=false;
                    }
                }

                this.loading = false;
            }, () => {        					
                
                this.loading= false;                   
                
            }); 
        }
    },
    created(){


        // if(this.itemsdefault!=null && this.itemsdefault.length > 0 ){
        //     this.items = this.itemsdefault;
        if(this.itemdefault!=null  ){
            this.items = [this.itemdefault];
        }else{


            if(this.value!=null && this.value!=''){
                this.recuperaAgregado(this.value);
               /* let objAgregado = {pk: this.value};

                if(this.id_agregado!=null && this.id_agregado!='null'){
                    // console.log('id', this.id_agregado);
                    objAgregado["id"] = this.id_agregado;
                    // console.log('id', objAgregado);
                }else if(this.tag_agregado!=null && this.tag_agregado!=''){
                    // console.log('tag', this.tag_agregado);
                    objAgregado["tag"] = this.tag_agregado;
                    // console.log('tag', objAgregado);
                }


                axios.get ('/agregados/json/pk',{params: objAgregado})
                .then(res => {					
                    if(res.data){                    
                        if(res.data.data && res.data.data.length > 0){
                            
                            this.items = res.data.data;                            
                            this.valorRecuperadoCreated = this.items[0];
                            this.recuperadoCreated=false;
                        }
                    }

                    this.loading = false;
                }, err => {        					
                    
                    this.loading= false;                   
                    
                }); */
            }

        }

        // if(this.selected!= null && this.selected.length > 0 ){
        //      this.value_data = this.selected;
        // }
    }
}
</script>